// google Analytics
window.dataLayer = window.dataLayer || [];
function gtag(...args) {
  window.dataLayer.push(args);
}
gtag('js', new Date());
gtag('config', 'UA-111443532-2');
